import CampusMap from "./CampusMap";

export default CampusMap;
